module.exports = __webpack_public_path__ + "img/22.bee0d13b.png";